import React from "react";
import { HiOutlineUserGroup } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import OptionToggleRow from "./OptionToggleRow";

interface AddToGroupsToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  title?: string;
  description?: string;
  icon?: React.ReactNode;
}

const AddToGroupsToggle: React.FC<AddToGroupsToggleProps> = ({
  enabled,
  onChange,
  title,
  description,
  icon,
}) => {
  const { t } = useTranslation();

  return (
    <OptionToggleRow
      icon={icon ?? HiOutlineUserGroup}
      iconClassName={icon ? undefined : "text-blue-600"}
      title={title ?? t("businessCardPage.optionsTab.addToGroups.title")}
      description={
        description ?? t("businessCardPage.optionsTab.addToGroups.subLabel")
      }
      enabled={enabled}
      onChange={onChange}
    />
  );
};

export default AddToGroupsToggle;
